import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { MODERNIZED_SEGMENTATION_PAGE } from '../constants';

export const useIsModernizedSegmentationPageEnabled = () =>
  useFeatureFlag(MODERNIZED_SEGMENTATION_PAGE);
